import { QueryResult, useQuery } from '@apollo/client'
import {
  Country,
  FindPossibleYearsAndCompaniesForRankingReportQuery,
  FindPossibleYearsAndCompaniesForRankingReportQueryVariables,
  GetRankingReportsByCountryAndFiltersQuery,
  GetRankingReportsByCountryAndFiltersQueryVariables,
  RankingReportFilterInput,
  ReportType,
  FindTargetReportsByCountryAndCompanyQuery,
  FindTargetReportsByCountryAndCompanyQueryVariables,
  CursorPaginationReportInput,
  FindReportsInDownloadsViewByCountryTypeQuery,
  FindReportsInDownloadsViewByCountryTypeQueryVariables,
} from '../../types'
import {
  GET_REPORTS_IN_DOWNLOADS_VIEW_BY_COUNTRY_TYPE,
  RANKING_REPORT_BY_COUNTRY_AND_FILTERS,
  YEARS_AND_COMPANIES_FOR_RANKING_REPORT,
  GET_TARGET_REPORTS_BY_COUNTRY_AND_COMPANY,
} from './Queries'

export const useGetReportsByCountryAndType = (
  countries: Country[],
  reportType: ReportType,
  skip: boolean,
): QueryResult<FindReportsInDownloadsViewByCountryTypeQuery, FindReportsInDownloadsViewByCountryTypeQueryVariables> => {
  return useQuery<FindReportsInDownloadsViewByCountryTypeQuery, FindReportsInDownloadsViewByCountryTypeQueryVariables>(
    GET_REPORTS_IN_DOWNLOADS_VIEW_BY_COUNTRY_TYPE,
    {
      variables: { countries, reportType, pagination: {} },
      fetchPolicy: 'network-only',
      notifyOnNetworkStatusChange: true,
      skip,
    },
  )
}

export const useGetTargetReportsByCountryAndCompany = (
  country: Country,
  companyId: string,
): QueryResult<FindTargetReportsByCountryAndCompanyQuery, FindTargetReportsByCountryAndCompanyQueryVariables> => {
  return useQuery<FindTargetReportsByCountryAndCompanyQuery, FindTargetReportsByCountryAndCompanyQueryVariables>(
    GET_TARGET_REPORTS_BY_COUNTRY_AND_COMPANY,
    {
      variables: { country, companyId },
      fetchPolicy: 'network-only',
    },
  )
}

export const usePossibleYearsAndCompaniesForRankingReport = (
  country?: Country,
): QueryResult<FindPossibleYearsAndCompaniesForRankingReportQuery, FindPossibleYearsAndCompaniesForRankingReportQueryVariables> => {
  return useQuery<FindPossibleYearsAndCompaniesForRankingReportQuery, FindPossibleYearsAndCompaniesForRankingReportQueryVariables>(
    YEARS_AND_COMPANIES_FOR_RANKING_REPORT,
    {
      variables: { country },
      fetchPolicy: 'network-only',
    },
  )
}

export const useRankingReportsByCountryAndFilters = (
  countries: Country[],
  filters: RankingReportFilterInput,
  pagination: CursorPaginationReportInput,
): QueryResult<GetRankingReportsByCountryAndFiltersQuery, GetRankingReportsByCountryAndFiltersQueryVariables> => {
  return useQuery<GetRankingReportsByCountryAndFiltersQuery, GetRankingReportsByCountryAndFiltersQueryVariables>(
    RANKING_REPORT_BY_COUNTRY_AND_FILTERS,
    {
      variables: {
        countries,
        filters,
        pagination,
      },
      fetchPolicy: 'network-only',
      notifyOnNetworkStatusChange: true,
    },
  )
}
